export default __webpack_public_path__ + "static/media/route-planner.07ee9330.md";